import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UserProfile } from '../models/auth.model';

/**
 * Accès runtime aux URLs et au mode stub
 * (après patch éventuel de {@code environment} / {@code app-config.json}).
 */
@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  /** Base API EasyLoc (sans slash final). */
  getApiUrl(): string {
    return this.stripTrailingSlash(environment.apiUrl);
  }

  /** Base API Launcher (auth refresh / logout). */
  getLauncherApiUrl(): string {
    return this.stripTrailingSlash(environment.launcherApiUrl);
  }

  /** Front Launcher (redirection login / « ouvrir le launcher »). */
  getLauncherFrontUrl(): string {
    return this.stripTrailingSlash(environment.otherAppUrl);
  }

  /** True si l'auth SSO est remplacée par un utilisateur fixe (dev). */
  isStubAuth(): boolean {
    return environment.stubAuth === true;
  }

  /** Profil stub, ou {@code null} si stub désactivé / non configuré. */
  getStubUser(): UserProfile | null {
    if (!this.isStubAuth() || !environment.stubUser) {
      return null;
    }
    return { ...environment.stubUser };
  }

  private stripTrailingSlash(url: string): string {
    let end = url.length;
    while (end > 0 && url.charAt(end - 1) === '/') {
      end -= 1;
    }
    return end === url.length ? url : url.slice(0, end);
  }
}
